module.exports = __webpack_public_path__ + "static/media/bewal.d493da17.jpg";